import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '../../../theming/ThemeProvider'
import { View, TouchableOpacity } from 'react-native'
import useStyles from './useStyles'
import { Button, Icon, Txt, Input } from '../..'

const SearchByOrderNumber = ({ initialValue, handleSearch, onClose }) => {
  const { theme } = useTheme()
  const styles = useStyles(theme)
  const [orderNumber, setOrderNumber] = useState(initialValue)

  useEffect(() => {
    setOrderNumber(initialValue)
  }, [initialValue])

  const handleState = (value) => {
    if (isNaN(+value)) return
    setOrderNumber(value)
  }

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Txt
          text='Search for a specific load'
          identity='body2Bold'
        />
        <TouchableOpacity
          activeOpacity={0.8}
          onPress={onClose}
        >
          <Icon
            name='Exit'
            width={10}
            height={10}
            fill={theme.SLATE_GRAY}
          />
        </TouchableOpacity>
      </View>
      <Txt
        text='Write and press the button to search'
        identity='body3'
      />
      <View style={styles.form}>
        <Input
          placeholder='Order Number'
          name='orderNumber'
          keyboardType='numeric'
          value={orderNumber}
          onChange={(_, value) => handleState(value)}
        />
        <Button
          title='Search'
          onPress={() => {
            handleSearch(orderNumber)
            onClose()
          }}
          style={styles.button}
        />
      </View>
    </View>
  )
}

SearchByOrderNumber.propTypes = {
  initialValue: PropTypes.string,
  handleSearch: PropTypes.func,
  onClose: PropTypes.func
}

export default SearchByOrderNumber
